module.exports = __webpack_public_path__ + "img/H30-cape-verde.b72fb18d.png";